import { render, staticRenderFns } from "./DietaryFormFields.vue?vue&type=template&id=68f5199d&scoped=true"
import script from "./DietaryFormFields.vue?vue&type=script&lang=js"
export * from "./DietaryFormFields.vue?vue&type=script&lang=js"
import style0 from "./DietaryFormFields.vue?vue&type=style&index=0&id=68f5199d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5199d",
  null
  
)

export default component.exports